import CaretLeftIcon from "@shared/svg/caret-left.svg?react";
import CaretRighttIcon from "@shared/svg/caret-right.svg?react";
import Calendar from "react-calendar";
import CalendarStyles from "../../css/calendar.module.css";
import Selector from "./components/Selector/Selector";
import React, { useState, useEffect } from "react";
import { formatTime, getUserTime } from "./utils";
import { hours, Meridiem, minutes, TIME_FORMATS } from "./constants";
export type CalendarValueType = string | Date | string[] | Date[];

type CalendarComponentPropsType = {
  calendarType?: string;
  showNeighboringMonth?: boolean;
  value: CalendarValueType;
  maxDate?: Date;
  minDate?: Date;
  className?: string;
  onChange: (value: CalendarValueType) => void;
  showDoubleView?: boolean;
  selectRange?: boolean;
  allowPartialRange?: boolean;
  allowTimeSelect?: boolean;
  initialHourValue?: string;
  initialMinuteValue?: string;
  initialMeridiemValue?: string;
  onTimeChange?: (e: string) => void;
  dateSelected?: boolean;
  timeValue?: string;
  timeFormat?: string;
};

const CalendarComponent = ({
  calendarType = "ISO 8601",
  showNeighboringMonth = false,
  value,
  maxDate = null,
  minDate = null,
  className = "",
  onChange,
  showDoubleView = false,
  selectRange = false,
  allowPartialRange = false,
  allowTimeSelect = false,
  initialHourValue = "",
  initialMinuteValue = "",
  initialMeridiemValue = "",
  onTimeChange,
  dateSelected,
  timeValue,
  timeFormat = TIME_FORMATS.TWELVE_HOUR,
}: CalendarComponentPropsType) => {
  const formattedTime = formatTime(timeValue);
  const [time, setTime] = useState({
    hour: formattedTime ? formattedTime.hour : initialHourValue,
    minute: formattedTime ? formattedTime.minute : initialMinuteValue,
    meridiem:
      timeFormat === TIME_FORMATS.TWENTY_FOUR_HOUR
        ? null
        : formattedTime
        ? formattedTime.meridiem
        : initialMeridiemValue,
  });

  useEffect(() => {
    if (onTimeChange) {
      if (timeFormat === TIME_FORMATS.TWENTY_FOUR_HOUR) {
        onTimeChange(`${time?.hour}:${time?.minute}`);
      } else {
        onTimeChange(`${time?.hour}:${time?.minute} ${time?.meridiem}`);
      }
    }
  }, [time, timeFormat]);

  useEffect(() => {
    if (
      (initialHourValue && initialMinuteValue && initialMeridiemValue) ||
      timeValue
    )
      return;

    //fetch user current time and set in state
    const time = getUserTime(timeFormat);
    setTime({
      hour: time.hour,
      minute: time.minute,
      meridiem:
        timeFormat === TIME_FORMATS.TWENTY_FOUR_HOUR ? null : time.meridiem,
    });
  }, [
    initialHourValue,
    initialMinuteValue,
    initialMeridiemValue,
    timeValue,
    timeFormat,
  ]);

  // to set initial value w/o on change for better UX
  useEffect(() => {
    if (!dateSelected && allowTimeSelect) onChange(new Date());
  }, [dateSelected, allowTimeSelect]);

  return (
    <div className="flex">
      <Calendar
        calendarType={calendarType}
        showNeighboringMonth={showNeighboringMonth}
        className={`${
          showDoubleView
            ? CalendarStyles.dateRangeCalendar
            : CalendarStyles.dateInputCalendar
        } ${className}`}
        value={value}
        maxDate={maxDate}
        minDate={minDate}
        onChange={onChange}
        nextLabel={<CaretRighttIcon width={20} height={20} />}
        prevLabel={<CaretLeftIcon width={20} height={20} />}
        showDoubleView={showDoubleView}
        selectRange={selectRange}
        allowPartialRange={allowPartialRange}
      />

      {/* time component */}
      {allowTimeSelect && (
        <div
          style={{
            display: "flex",
            border: `2px solid #f3f4f6`,
            borderRadius: "1%",
            backorundColor: "#f3f4f6",
            marginLeft: "10px",
          }}
        >
          <Selector
            stylings={{ borderRight: `4px solid #f3f4f6` }}
            list={hours(timeFormat)}
            onChange={(e) => setTime({ ...time, hour: e })}
            value={time.hour}
          />
          <Selector
            stylings={
              timeFormat === TIME_FORMATS.TWELVE_HOUR && {
                borderRight: `4px solid #f3f4f6`,
              }
            }
            list={minutes}
            onChange={(e) => setTime({ ...time, minute: e })}
            value={time.minute}
          />
          {timeFormat === TIME_FORMATS.TWELVE_HOUR && (
            <Selector
              list={Meridiem}
              onChange={(e) => setTime({ ...time, meridiem: e })}
              value={time.meridiem}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CalendarComponent;
